/* Copie robuste : navigator.clipboard si dispo/autorisé, sinon fallback
   textarea + execCommand (vieux navigateurs, iframes, permissions refusées).
   Retourne une Promise<boolean> — true si la copie a réussi. */
export const copyText = (text) => {
  return new Promise((resolve) => {
    const fallback = () => {
      try {
        const ta = document.createElement("textarea");
        ta.value = String(text);
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.top = "-1000px";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, ta.value.length);
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        resolve(!!ok);
      } catch (e) {
        resolve(false);
      }
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      let settled = false;
      const once = (fn) => () => { if (!settled) { settled = true; fn(); } };
      // certaines permissions restent suspendues sans jamais répondre → timeout
      setTimeout(once(fallback), 600);
      navigator.clipboard.writeText(String(text)).then(
        once(() => resolve(true)),
        once(fallback)
      );
    } else {
      fallback();
    }
  });
};
